module.exports = __webpack_public_path__ + "media/step4_animation.af36db72.webm";